import {
  Wrapper,
  Container,
  CardTitle,
  CardExtra,
  CardPoints,
  CardPointImage,
  DoneText,
  BlockedText,
  CardPointValue,
  MissionStat,
  MissionStatWrapper,
  MissionStatBar,
  InstructionStart
} from './styles'
import { Icon } from '../../assets/icons'
import { MissionModel } from '../../../domain/model/mission.model'
import { useGame } from '../../contexts'
import { getAssetUrl } from '../../utils/assets_helpers'
import { useEffect, useState } from 'react'
import { orderByPosition } from '../../utils/mission_helpers'
import { t } from '../../adapters/translate/translate'
import { GameState } from '../../../domain/enum/game-state.enum'

type Props = {
  className?: string;
  onAction: (mission:MissionModel) => void;
  type: 'done-group' | 'done' | 'current' | 'blocked' ;
  points?: number;
  mission:MissionModel;
  hasGift?: boolean;
  hideBar:boolean;
  borderColor?: any;
  firstMission: boolean;
}

const MissionCard = ({
  className,
  onAction,
  type = 'current',
  mission,
  hideBar = true,
  borderColor,
  firstMission
}: Props) => {
  const { game } = useGame()
  const [points, setPoints] = useState(0)

  const icons = {
    done: 'done-point',
    'done-group': 'done-group-point',
    current: 'current-point',
    blocked: 'blocked'
  }

  function loadPoints () {
    let accumulatedPoints = mission.pointsIfCorrect || 0

    mission.childMissions.sort(orderByPosition).forEach((currentValue: MissionModel) => {
      accumulatedPoints += currentValue.pointsIfCorrect || 0
    })

    setPoints(accumulatedPoints)
  }

  useEffect(() => {
    loadPoints()
  }, [])

  return (
    <Wrapper>
      <Wrapper>
        <MissionStatWrapper>
          <MissionStat parent type={type} className={hideBar ? 'hide-bar' : ''}>
            <Icon name={icons[type]} />
          </MissionStat>
          {!hideBar && <MissionStatBar type={type}/>}
        </MissionStatWrapper>

        <Container type={type} onClick={type === 'current' ? () => onAction(mission) : () => {}} className={className} borderColor={game?.baseColor || '#fff'}>

          <CardTitle style={{ color: type === 'done' || type === 'blocked' ? game?.textColor : '#fff' }} type={type}>
            { mission.name }

            {type === 'done' && (
              <DoneText>{t('Done')}</DoneText>
            )}

            {type === 'blocked' && (
              <BlockedText style={{ color: game?.textColor || '#fff' }}>{t('Blocked')} <Icon name="blocked" /></BlockedText>
            )}
            { game.gameState === GameState.APPROVAL && firstMission && type === 'current' && (
            <InstructionStart>
              <Icon name={'arrow-connection-line'} />
              <h4>{t('Comece clicando aqui')}</h4>
            </InstructionStart>
            )}
          </CardTitle>

          <CardExtra>
            {type === 'current' && points > 0 && (
              <>
              <CardPoints>
                <CardPointValue>+{points}</CardPointValue>
                {game?.pointsMissionGroupImage && <CardPointImage src={getAssetUrl('pointsMissionGroupImage', game?.pointsMissionGroupImage)}/>}
              </CardPoints>

              <Icon name="arrow-right" />
              </>
            )}
          </CardExtra>

        </Container>
      </Wrapper>
    </Wrapper>
  )
}

export default MissionCard
